export default function Contact (id = -1, name = "", phonenumber = "") {
    this.id = id;
    this.name = name;
    this.phonenumber = phonenumber;
 }



// WEBPACK FOOTER //
// ./src/models/Contact.js